import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import SearchLogs from "./SearchLogs";
import { getAll, getLogs, exportData } from "./SearchLogsAction";

const mapStateToProps = (state, ownProps) => {
  return {
    // search: state.Search,
    searchLogs: state.SearchLogs,

  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    getAll, 
    getLogs,
    exportData
  }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchLogs);
